import type { DCOperation } from "../types";

const stringOperations: DCOperation[] = [
  {
    name: "IS_EMPTY",
    label: "Está vacío",
  },
  {
    name: "IS_NOT_EMPTY",
    label: "No está vacío",
  },
  {
    name: "EQUALS",
    label: "Es igual a",
    needsComparativeValue: true,
    comparativeValueType: "string",
  },
  {
    name: "NOT_EQUALS",
    label: "No es igual a",
    needsComparativeValue: true,
    comparativeValueType: "string",
  },
  {
    name: "CONTAINS",
    label: "Contiene",
    needsComparativeValue: true,
    comparativeValueType: "string",
  },
  {
    name: "NOT_CONTAINS",
    label: "No contiene",
    needsComparativeValue: true,
    comparativeValueType: "string",
  },
  {
    name: "STARTS_WITH",
    label: "Empieza con",
    needsComparativeValue: true,
    comparativeValueType: "string",
  },
  {
    name: "NOT_STARTS_WITH",
    label: "No empieza con",
    needsComparativeValue: true,
    comparativeValueType: "string",
  },
  {
    name: "ENDS_WITH",
    label: "Termina con",
    needsComparativeValue: true,
    comparativeValueType: "string",
  },
  {
    name: "NOT_ENDS_WITH",
    label: "No termina con",
    needsComparativeValue: true,
    comparativeValueType: "string",
  },
  {
    name: "MATCHES",
    label: "Coincide con la expresión",
    needsComparativeValue: true,
    comparativeValueType: "regex",
  },
  {
    name: "NOT_MATCHES",
    label: "No coincide con la expresión",
    needsComparativeValue: true,
    comparativeValueType: "regex",
  },
];

const numberOperations: DCOperation[] = [
  {
    name: "IS_EMPTY",
    label: "Está vacío",
  },
  {
    name: "IS_NOT_EMPTY",
    label: "No está vacío",
  },
  {
    name: "EQUALS",
    label: "Es igual a",
    needsComparativeValue: true,
    comparativeValueType: "number",
  },
  {
    name: "NOT_EQUALS",
    label: "No es igual a",
    needsComparativeValue: true,
    comparativeValueType: "number",
  },
  {
    name: "GREATER_THAN",
    label: "Es mayor a",
    needsComparativeValue: true,
    comparativeValueType: "number",
  },
  {
    name: "LESS_THAN",
    label: "Es menor a",
    needsComparativeValue: true,
    comparativeValueType: "number",
  },
  {
    name: "GREATER_THAN_OR_EQUAL",
    label: "Es mayor o igual a",
    needsComparativeValue: true,
    comparativeValueType: "number",
  },
  {
    name: "LESS_THAN_OR_EQUAL",
    label: "Es menor o igual a",
    needsComparativeValue: true,
    comparativeValueType: "number",
  },
  {
    name: "BETWEEN",
    label: "Está en el rango",
    needsComparativeRange: true,
    comparativeValueType: "number",
  },
];

const booleanOperations: DCOperation[] = [
  {
    name: "IS_EMPTY",
    label: "Está vacío",
  },
  {
    name: "IS_NOT_EMPTY",
    label: "No está vacío",
  },
  {
    name: "IS_TRUE",
    label: "Es verdad",
  },
  {
    name: "IS_FALSE",
    label: "Es falso",
  },
  {
    name: "EQUALS",
    label: "Es igual a",
    comparativeValueType: "boolean",
    needsComparativeValue: true,
  },
  {
    name: "NOT_EQUALS",
    label: "No es igual a",
    comparativeValueType: "boolean",
    needsComparativeValue: true,
  },
];

export const dateScopeOperations: DCOperation[] = [
  {
    name: "ANY",
    label: "Cualquiera",
  },
  {
    name: "EQUALS",
    label: "Es igual a",
    needsComparativeValue: true,
    comparativeValueType: "date",
  },
  {
    name: "NOT_EQUALS",
    label: "No es igual a",
    needsComparativeValue: true,
    comparativeValueType: "date",
  },
  {
    name: "AFTER",
    label: "Es después de",
    needsComparativeValue: true,
    comparativeValueType: "date",
  },
  {
    name: "BEFORE",
    label: "Es antes de",
    needsComparativeValue: true,
    comparativeValueType: "date",
  },
  {
    name: "AFTER_EQUALS",
    label: "Es después o igual a",
    needsComparativeValue: true,
    comparativeValueType: "date",
  },
  {
    name: "BEFORE_EQUALS",
    label: "Es antes o igual a",
    needsComparativeValue: true,
    comparativeValueType: "date",
  },
  {
    name: "BETWEEN",
    label: "Está dentro del rango",
    needsComparativeRange: true,
    comparativeValueType: "date",
  },
];

export const userScopeOperations: DCOperation[] = [
  {
    name: "ANY",
    label: "Cualquiera",
  },
  {
    name: "EQUALS",
    label: "Es igual a",
    needsComparativeValue: true,
  },
  {
    name: "NOT_EQUALS",
    label: "No es igual a",
    needsComparativeValue: true,
  },
];

export const dateOperations: DCOperation[] = [
  {
    name: "EXIST",
    label: "Existe",
  },
  {
    name: "NOT_EXIST",
    label: "No existe",
  },
  {
    name: "IS_EMPTY",
    label: "Está vacía",
  },
  {
    name: "IS_NOT_EMPTY",
    label: "No está vacía",
  },
  {
    name: "EQUALS",
    label: "Es igual a",
    needsComparativeValue: true,
    comparativeValueType: "date",
  },
  {
    name: "NOT_EQUALS",
    label: "No es igual a",
    needsComparativeValue: true,
    comparativeValueType: "date",
  },
  {
    name: "IS_AFTER",
    label: "Es despues a",
    needsComparativeValue: true,
    comparativeValueType: "date",
  },
  {
    name: "IS_BEFORE",
    label: "Es antes a",
    needsComparativeValue: true,
    comparativeValueType: "date",
  },
  {
    name: "IS_IN_OR_AFTER",
    label: "Es despues o igual a",
    needsComparativeValue: true,
    comparativeValueType: "date",
  },
  {
    name: "IS_IN_OR_BEFORE",
    label: "Es antes o igual a",
    needsComparativeValue: true,
    comparativeValueType: "date",
  },
];

export const arrayOperations: DCOperation[] = [
  {
    name: "EXIST",
    label: "Existe",
  },
  {
    name: "NOT_EXIST",
    label: "No existe",
  },
  {
    name: "IS_EMPTY",
    label: "Está vacía",
  },
  {
    name: "IS_NOT_EMPTY",
    label: "No está vacía",
  },
  {
    name: "CONTAINS",
    label: "Contiene",
    comparativeValueType: "string",
    needsComparativeValue: true,
  },
  {
    name: "NOT_CONTAINS",
    label: "No contiene",
    comparativeValueType: "string",
    needsComparativeValue: true,
  },
  {
    name: "LENGTH_EQUAL",
    label: "Longitud es igual a",
    comparativeValueType: "positive-integer",
    needsComparativeValue: true,
  },
  {
    name: "LENGTH_NOT_EQUAL",
    label: "Longitud es diferente a",
    comparativeValueType: "positive-integer",
    needsComparativeValue: true,
  },
  {
    name: "LENGTH_GREATER_THAN",
    label: "Longitud mayor a",
    comparativeValueType: "positive-integer",
    needsComparativeValue: true,
  },
  {
    name: "LENGTH_LESS_THAN",
    label: "Longitud menor a",
    comparativeValueType: "positive-integer",
    needsComparativeValue: true,
  },
  {
    name: "LENGTH_GREATER_THAN_OR_EQUAL",
    label: "Longitud mayor o igual a",
    comparativeValueType: "positive-integer",
    needsComparativeValue: true,
  },
  {
    name: "LENGTH_LESS_THAN_OR_EQUAL",
    label: "Longitud menor o igual a",
    comparativeValueType: "positive-integer",
    needsComparativeValue: true,
  },
];

export type DataCenterTypeOperationTypes =
  | "string"
  | "number"
  | "year"
  | "date"
  | "boolean"
  | "array"
  | "dateScope"
  | "userScope"
  | "select"
  | "float"
  | "file"
  | "email"
  | "files"
  | "table";
export const DataCenterConditionOperations: Record<
  DataCenterTypeOperationTypes,
  DCOperation[]
> = {
  string: stringOperations,
  email: stringOperations,
  number: numberOperations,
  float: numberOperations,
  date: dateOperations,
  boolean: booleanOperations,
  array: arrayOperations,
  dateScope: dateScopeOperations,
  userScope: userScopeOperations,
  year: dateOperations,
  select: [],
  file: [],
  files: [],
  // Una tabla no se usa como condicion de centro de datos.
  table: [],
};
